import React from 'react'
import PropTypes from 'prop-types'
import { Box, Tooltip } from '@mui/material'

/**
 * Historia 120 — Bloques 27/29 (Jupiter, ENMIENDAS 06 y 08) --
 * `features/S233-ui-previsualizacion-y-barra-de-lote-jupiter.feature` (S239) y
 * `features/S243-workflow-y-distintivo-en-tres-widgets-jupiter.feature` (S245).
 *
 * El distintivo PERMANENTE del lote al que pertenece un job. Lo llevan TODOS los miembros, estén
 * seleccionados o no, porque su función es que el operario vea de un vistazo **qué va junto** ANTES de
 * pulsar nada: un distintivo que solo apareciera en el seleccionado no resolvería el hallazgo del PO.
 * Un job SIN lote no lleva ninguno — si lo llevara, el operario creería que pertenece a algo.
 *
 * 🔒 **ENMIENDA 08 — ES UN SOLO COMPONENTE PARA LAS CUATRO SUPERFICIES** (las listas de los tres
 * widgets y el título del job mostrado en dos de ellos). Tenerlo aquí, y no repetido en cada uno, es
 * lo que impide que un distintivo acabe con su propio criterio de color y vuelva a partir la identidad
 * del lote en la misma pantalla (S245). El color sale siempre de `batchBadgeColor(batchId)` (S244).
 *
 * ⚠️ RN2/INV6: es identidad de pertenencia y NADA más — no muestra cantidad, progreso ni porcentaje
 * del lote. El color y la etiqueta se derivan del `batchId` que el job ya publica (F3), sin ninguna
 * petición adicional.
 */
const BatchBadge = ({ badge, size = 10 }) => {
  if (!badge) return null
  return (
    <Tooltip title={badge.label}>
      <Box
        data-testid='batch-badge'
        aria-label={badge.label}
        style={{ backgroundColor: badge.color }}
        sx={{ width: size, height: size, borderRadius: '50%', flexShrink: 0 }}
      />
    </Tooltip>
  )
}

BatchBadge.propTypes = {
  badge: PropTypes.shape({ color: PropTypes.string, label: PropTypes.string }),
  size: PropTypes.number
}

export default BatchBadge
